<template>
  <OmtLayoutContainer>
    <OmtRow>
      <OmtTypography mb="24px" as="h1-bold" color="var(--colors-priary-gray)">
        Descreva os detalhes para revisão
      </OmtTypography>
    </OmtRow>
    <OmtRow>
      <CFlex flexDirection="column" alignItems="flex-end">
        <OmtTextarea
          padding="12px"
          mb="8px"
          placeholder="Descreva os motivos da reclamação aqui."
          :initialValue="description"
          @change="handleChange"
          maxlength="500"
        ></OmtTextarea>
        <OmtTypography as="h3-regular" lineHeight="18px" color="var(--colors-light-primary-gray2)">
          {{ description.length }}/500
        </OmtTypography>
      </CFlex>
    </OmtRow>
    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['342px !important']" @click="goToNextPage" :disabled="description.length === 0">Enviar</OmtButton>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "DetailsOuvidoria",
  components: {},
  data() {
    return {
      description: ""
    };
  },
  methods: {
    ...mapMutations("sac", ["SET_NEW_SOLICITATION", "CLEAN_NEW_SOLICITATION"]),
    goToNextPage() {
      this.SET_NEW_SOLICITATION({
        observacao: this.description
      });
      this.$router.push("/ouvidoria/criar/imagem-analise");
    },
    handleChange(obs) {
      this.description = obs;
    }
  },
  async mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>
